import { ReactNode } from "react";
import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from "react-hook-form";

type FormProps<TFieldValues extends FieldValues> = {
  form: UseFormReturn<TFieldValues>;
  onSubmit: SubmitHandler<TFieldValues>;
  children: ReactNode;
  id?: string;
  className?: string;
  noValidate?: boolean;
};

function Form<TFieldValues extends FieldValues>({
  form,
  onSubmit,
  children,
  id,
  className,
  noValidate = true,
}: FormProps<TFieldValues>) {
  return (
    <FormProvider {...form}>
      <form
        id={id}
        className={className}
        onSubmit={form.handleSubmit(onSubmit)}
        noValidate={noValidate}
      >
        {children}
      </form>
    </FormProvider>
  );
}

export default Form;
